
import React from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { cn } from '@/lib/utils';
import { Users as UsersIcon, Filter } from 'lucide-react';

interface AudienceTypeSelectorProps {
  audienceType: 'all' | 'filtered';
  onAudienceTypeChange: (value: 'all' | 'filtered') => void;
}

const AudienceTypeSelector: React.FC<AudienceTypeSelectorProps> = ({
  audienceType,
  onAudienceTypeChange
}) => {
  return (
    <div className="space-y-4">
      <Label>Who do you want to target?</Label>
      <RadioGroup 
        value={audienceType} 
        onValueChange={onAudienceTypeChange}
        className="space-y-3"
      >
        <div className={cn(
          "flex items-start space-x-3 rounded-md border p-4",
          audienceType === 'all' && "border-primary bg-primary/5"
        )}>
          <RadioGroupItem value="all" id="audience-all" className="mt-1" />
          <div>
            <Label htmlFor="audience-all" className="text-base cursor-pointer font-medium flex items-center">
              <UsersIcon className="h-5 w-5 mr-2 text-primary" />
              All Customers
            </Label>
            <p className="text-sm text-muted-foreground mt-1">
              Send to all customers who have opted in to SMS marketing
            </p>
          </div>
        </div>
        <div className={cn(
          "flex items-start space-x-3 rounded-md border p-4",
          audienceType === 'filtered' && "border-primary bg-primary/5"
        )}>
          <RadioGroupItem value="filtered" id="audience-filtered" className="mt-1" />
          <div>
            <Label htmlFor="audience-filtered" className="text-base cursor-pointer font-medium flex items-center">
              <Filter className="h-5 w-5 mr-2 text-primary" />
              Filtered Audience
            </Label>
            <p className="text-sm text-muted-foreground mt-1">
              Target specific customer segments based on behavior and attributes
            </p>
          </div>
        </div>
      </RadioGroup>
    </div>
  );
};

export default AudienceTypeSelector;
